import {createApp} from 'vue'
import options from './FeatureNavigationTeam.options'

const el = '.kb-component--feature-navigation-team'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FeatureNavigationTeamDOM)=>{
            const template = FeatureNavigationTeamDOM.outerHTML
            options.template = template

            const teamId = FeatureNavigationTeamDOM.dataset.teamId
            const component = createApp(options, { teamId }).use(Store)
            component.mount(FeatureNavigationTeamDOM)
        })
    }
}